import DailyExchangeRate from "./DailyExchangeRate";

const DailyExchangeRateConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/dailyExchangeRates',
            element: <DailyExchangeRate />,
        },
    ],
}

export default DailyExchangeRateConfig;
